import { BotSequenceTestRunInterface, BotSequenceTestRunTrace, CreateTestRunBody, CreateTestRunResult } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

// Mirrors apps/server/src/API/SequenceTestRuns/SequenceTestRuns.Controller.ts
// (which proxies to bull — see BullAPI's createSequenceTestRun and friends).
//
// Studio talks to the SERVER here, never to bull: bull's endpoints authenticate with the
// shared internal API_TOKEN, which must not reach a browser. These are member-authenticated
// and Swivl-admin only.
export class SequenceTestRunsAPI {
  static async create(orgId: number, body: CreateTestRunBody): Promise<CreateTestRunResult> {
    return APIService.Server.post<CreateTestRunResult>(`/sequence-test-runs/org/${orgId}`, body);
  }

  static async listActive(orgId: number): Promise<BotSequenceTestRunInterface[]> {
    return APIService.Server.get<BotSequenceTestRunInterface[]>(`/sequence-test-runs/org/${orgId}`);
  }

  static async getTrace(runId: number): Promise<BotSequenceTestRunTrace> {
    return APIService.Server.get<BotSequenceTestRunTrace>(`/sequence-test-runs/${runId}`);
  }

  static async cancel(runId: number): Promise<BotSequenceTestRunInterface> {
    return APIService.Server.post<BotSequenceTestRunInterface>(`/sequence-test-runs/${runId}/cancel`);
  }

  static async manualUnenroll(orgId: number, enrollmentId: number): Promise<{ closed: boolean; reconcileRequestId: number | null }> {
    return APIService.Server.post<{ closed: boolean; reconcileRequestId: number | null }>(
      `/sequence-test-runs/org/${orgId}/enrollment/${enrollmentId}/manual-unenroll`
    );
  }

  static async forceDispatchTick(): Promise<{ enqueued: boolean }> {
    return APIService.Server.post<{ enqueued: boolean }>(`/sequence-test-runs/dispatch-tick`);
  }

  static async forceSchedulerRun(orgId: number): Promise<{ runId: number | null }> {
    return APIService.Server.post<{ runId: number | null }>(`/sequence-test-runs/org/${orgId}/scheduler-run`);
  }
}
